import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { getSessionAuthData } from '../states/session-auth/session-auth.selectors';
import { Subject, takeUntil } from 'rxjs';
import { sessionAuthData, sessionUserData } from '../interfaces/states-data';
import { JwtHelperService } from '@auth0/angular-jwt';
import { getSessionUserData } from '../states/session-user/session-user.selectors';
// import { UisrAuthService } from '../services/uisr-auth.service';

@Directive({ selector: '[appValidateAccessExperience]' })
export class ValidateAccessExperienceDirective {


  protected ngUnsubscribe: Subject<void> = new Subject<void>();


  // Auth States 

  sessionUserState: sessionUserData = {};


  sessionExist: boolean = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private store: Store<any>,
    private jwtHelper: JwtHelperService,
    // private authService: UisrAuthService
  ) {


    // Al recibir cambios del reducer - User
    this.store.pipe(select(getSessionUserData), takeUntil(this.ngUnsubscribe)).subscribe((data: sessionUserData) => {

      // Se guarda en local storage el estado obtenido
      localStorage.setItem('sessionUserState', JSON.stringify(data));

      // Se guarda en el componente local el estado obtenido
      this.sessionUserState = data;


    });

  }

  @Input()
  set appValidateAccessExperience(action: string | null | undefined) {
    // console.log('sessionAuthState', this.sessionAuthState)
    const requiredActions = this.sessionUserState.permissions_experience?.split(','); // Añade aquí las acciones que necesitas validar

    // console.log(this.sessionUserState.permissions_experience)
    if (action && requiredActions?.some(reqAction => action.includes(reqAction))) {
      // if (true) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
